// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__157b4","productName":"Table_productName__BkUwS"};